import { useJsApiLoader } from "@react-google-maps/api";

/** Single shared loader config — prevents the “Loader must not be called again” error. */
const LIBRARIES: "places"[] = ["places"]; // add "geometry" later if needed

export function useGoogleMaps() {
  return useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string,
    libraries: LIBRARIES,
    language: "en",
    region: "US",
  });
}
